import React from 'react';
import axios from 'axios';
import { useGoogleLogin  } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { userThirdPartyLogin } from '../utils/api-services/user';
import aMediator from './aMediator';

const GoogleLoginButton = ({label, entry, code}) => {

    const handleLogin = useGoogleLogin({
        onSuccess: async tokenResponse => {
            try {
                const res = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
                  headers: {
                    Authorization: `Bearer ${tokenResponse.access_token}`,
                  },
                });
                const response = res.data;
                console.log('User info:', response);
                if(response != null){
                    saveLogin({
                        name: response.name,
                        email: response.email,
                        photo: "",
                        entry: "Google"
                    });
                }
            }catch (err) {
                console.error('Failed to fetch user info', err);
            }
        },
        onError: error => {
          console.error('Google login failed', error);
        },
    });

    const saveLogin = async (payload) => {
        const obj = await userThirdPartyLogin(payload);
        if(obj?.Success){
            localStorage.setItem("session", obj.Data);
            aMediator(entry, code);
        }
    }

    const styles = {
        btn: {
            backgroundColor: '#fff',
            color: '#3c4043',
            width: '100%',
            padding: '7px',
            border: 'none',
            borderRadius: '5px',
            fontSize: '15px',
            border: '1px solid #dadce0',
            cursor: 'pointer',
            position: 'relative'
        },
        icon:{
            color: '#ea4335',
            fontSize: 18,
            position: 'absolute',
            top: 11,
            left: 13
        }
    }

    return (
        <button onClick={handleLogin} style={styles.btn}>
            <i className="fa fa-google" style={styles.icon}></i> {label}
        </button>
    )

}

export default GoogleLoginButton;